import { render, staticRenderFns } from "./PecaPublicitariaForm.vue?vue&type=template&id=49154b2e"
import script from "./PecaPublicitariaForm.vue?vue&type=script&lang=js"
export * from "./PecaPublicitariaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports